import React from 'react'
import IrregularInteraction from '../IrregularInteraction'
import ItemImage from '../ItemImage'
import image from '../../assets/images/item--power-strip@3x.png'

const path =
  'M74.14,67.27 L74.14,71.95 L63.83,77.9 L21.11,53.24 L21.11,48.53 L31.39,42.59 L74.14,67.27 Z'

const PowerStrip = props => (
  <IrregularInteraction
    path={path}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 74.14 84.9"
    sparksTop={91}
    sparksLeft={96}
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

PowerStrip.propTypes = IrregularInteraction.propTypes

export default PowerStrip



// WEBPACK FOOTER //
// ./src/components/items/PowerStrip.js